import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpComponent } from './components/help/help.component';
import {SharedModule} from '../shared/shared.module';
import { FeaturesComponent } from './components/features/features.component';
import { ChipsModule } from '../shared/components/app-chips/chips.module';
import { RichTextModule } from '../shared/components/rich-text/rich-text.module';



@NgModule({
  declarations: [HelpComponent, FeaturesComponent],
  imports: [
    RichTextModule,
    ChipsModule,
    CommonModule,
    SharedModule,
  ]
})
export class HelpModule { }
